
<template>
  <div class="leader-list" >
    <div 
      v-for="(leader, index) in leaders"
      :key="index"
      class="leader-item"
    >
    <img src="../../assets/xinxigongkai/1.png" class="imgCssLine" />
      <div class="leader-info"  v-scroll-animate="'fly-in-bottom'">
        
        <div class="nameDiv"><span>{{ leader.name }}</span></div>
       <div class="lineDiv"><span></span></div>
        <div class="positionDiv">{{ leader.position }}</div>
      </div>
      <!-- <div v-if="index < leaders.length - 1" class="divider"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leaders: {
      type: Array,
      required: true
    }
  }
}
</script>
<style  lang="scss" scoped>
.leader-list {
  width: 100%;
  box-sizing: border-box; 
  background:url('../../assets/xinxigongkai/bg.png');
  background-size: cover;
  overflow: hidden;
  padding-top:4rem;
  margin-top: 1rem;
  padding-bottom: 5rem;
}

.leader-item {
  /* padding: 2% 3%; */
  @media (max-width: 768px) {
    padding: 2.5% 4%;
  }
  /* position: relative;
  border-bottom: 1px solid #e5e5e5; */
}
 
.leader-info {
  width: 90vw;
  margin:0 auto;
  display:flex; 
  margin-bottom: 1rem;
  
  line-height: 1.5rem;
  gap: 8px;
 
  min-height: 56px;
  text-align: center;
  color:#000000;
   
  div.nameDiv{
    flex: 50%;
    span{
      font-size: 1.2rem;
      // font-weight: bold;
      display: inline-block;
       color:#015293;
      width: 5rem;
      margin: 0 auto;
      text-align: justify;
      text-align-last: justify;
      text-justify: distribute-all-lines;
      line-height: 1.8;
    }
  }
  div.lineDiv{
    flex: 1%;
    
    span{
      display:inline-block;
      width: 1px;
      height: 1.5rem;
      background: #333333;
    }
  }
  div.positionDiv{
    flex: 49%;
    font-size: 1rem;
  }
}
.imgCssLine{
  display:block;
  width: 90vw;
  height:2.8rem !important;
  // border:1px solid red;
  margin:0 auto;
  @media (max-width: 768px) {
    width: 99vw;
  }
}
  
</style>